import React, { useState, useRef,useEffect } from "react";
import { Table, Drawer, Rate, Tag, Spin } from "antd";
import { ReactComponent as CopyIcon } from "../../../Icons/copy.svg";
import Button2 from "../../../NewComponent/Button2/Button2";
import BriefModal from "./BriefModal";
import { toast } from "react-toastify";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { ReactComponent as PdfWhiteIcon } from "../../../Icons/pdfDark.svg";
import { ReactComponent as DeleteIcon } from "../../../Icons/delete.svg";
import { ReactComponent as SubmitIcon } from "../../../Icons/submit.svg";
import { ReactComponent as ApprovedIcon } from "../../../Icons/approved.svg";
import { ReactComponent as AwaitingIcon } from "../../../Icons/awaiting.svg";
import { deleteBriefHistory, fetchAttachmentURL, getInlineImage, submitQuestion, openAPiSingleData, getQuestionDraftData } from "../../../API/api";
import { bindActionCreators } from "redux";
import { useDispatch } from "react-redux";
import { Actions } from "../../../Action";
import { CURRENT_ROLE } from "../../../API/url";
import {SyncOutlined} from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import Content from "./Content";
import moment from "moment";
import TooltipComp from "../../../NewComponent/ToolTip/TooltipComp";
import styles from "./BriefModal.module.css";

export default function TableComp({ data, onClickFunc }) {
  const dispatch = useDispatch();
  const [tooltipOpenId, setTooltipOpenId] = useState(null);
  const isTipOpen = (id) => tooltipOpenId === id;
  const [tipSuppressUntilLeave, setTipSuppressUntilLeave] = useState(
    () => new Set()
  );
    const navigate = useNavigate();

  const suppressUntilLeave = (id) =>
    setTipSuppressUntilLeave((s) => new Set(s).add(id));

  const clearSuppression = (id) =>
    setTipSuppressUntilLeave((s) => {
      if (!s.has(id)) return s;
      const n = new Set(s);
      n.delete(id);
      return n;
    });
    const { advanceFilterModalToggle,updateAnswerTextForEditor,updateSubmissionTypeForEditor,updateAttachmentForEditor,questionDataForEditor, getScrollPositionInExpertOpen, getSeekerAttachment } = bindActionCreators(Actions, dispatch);
  const pdfRef = useRef(null);
  // Tracking locally submitted agenticIds so UI can flip to "Awaiting" immediately
  const [optimisticSubmitted, setOptimisticSubmitted] = useState(
    () => new Set()
  );
  const [pendingAgenticId, setPendingAgenticId] = useState(null);
  // Server truth OR optimistic truth -> considered "awaiting"
  const isAwaiting = (row) => {
    if (!row) return false;
    return optimisticSubmitted.has(row.agenticId) || !!row.submittedForReview;
  };
  useEffect(() => {
    if (!pendingAgenticId) return;
    let timer = null;
    const check = () => {
      try {
        const cancelledId = localStorage.getItem("briefReviewCancelId");
        if (cancelledId && cancelledId === pendingAgenticId) {
          // Revert optimistic awaiting state
          setOptimisticSubmitted((prev) => {
            const next = new Set(prev);
            next.delete(pendingAgenticId);
            return next;
          });
          // keep tooltip suppressed until mouse leaves
          suppressUntilLeave(pendingAgenticId);
          setTooltipOpenId(null);
          // clear flag and pending
          localStorage.removeItem("briefReviewCancelId");
          setPendingAgenticId(null);
        }
      } catch (_) {
        /* ignore storage errors */
      }
    };
    // check immediately, then poll a few times (fast, lightweight)
    check();
    timer = setInterval(check, 250);
    return () => {
      if (timer) clearInterval(timer);
       };
  }, [pendingAgenticId]);
    // Return text inside <h1>, or null if not found
   

  // runs whenever your table data refreshes
  useEffect(() => {
    if (!Array.isArray(data) || optimisticSubmitted.size === 0) return;
    setOptimisticSubmitted((prev) => {
      const next = new Set(prev);
      for (const row of data) {
        if (row.submittedForReview) next.delete(row.agenticId);
      }
      return next;
    });
  }, [data]);

  const getH1TextFromHtmlRegex = (htmlString) => {
    const match = htmlString.match(/<h1[^>]*>(.*?)<\/h1>/i); // Regex to find <h1> content
    return match ? match[1].trim() : null; // Return text inside <h1>, or null if not found
  };
  const [resp, setResp] = useState(null);
  const [open, setOpen] = useState(false);
  const [isStep, setIsStep] = useState(false);
  const [audio, setAudio] = useState(null);
  const [loading, setLoading] = useState(false);
  const [reviewedButtonBool,setReviewedButtonBoolean]=useState(false)
    const currentPath = useLocation();
  const onClickEdit=()=>{
    setLoading(true);
    if(resp.questionId !== null){
      getQuestionData(resp.questionId);
    }else{
    let payload = {
        question: resp.userQuery,
        domain: "",
        type: "Vizerto",
        topicUuid: resp.agenticId,
        express: false,
        additionalContext: "",
        emailUuid: null,
        watchlist:[],
        uplodedFiles: [],
        agenticId: resp.agenticId,
        expertId: localStorage.getItem('userUuid'),
        forceReroute:true

      }
    submitQuestion(payload).then(Res=>{
      resp.questionId=Res.data.data.questionUuid;
      getQuestionData(Res.data.data.questionUuid);
    }).catch(err=>{
      console.log(err);
    });
  }
  }
  const getQuestionData=(id)=>{
    setLoading(true);
    openAPiSingleData(id).then(res=>{
      if(res.data.data.length === 0) {
        setLoading(false);
        return;
      }
      let data = res.data.data[0];
      getScrollPositionInExpertOpen(window.scrollY)
          getSeekerAttachment(data.seekerAttachments)
          questionDataForEditor(data);
          updateSubmissionTypeForEditor('answer');
          if (data.attachments !== undefined) {
            updateAttachmentForEditor(data.attachments);
          }
          // if(data.draftExists){
          getQuestionDraftData(data.questionUuid).then(res => {
            if (res === undefined) return;
            if (res.data.data.length > 0) {
              updateAnswerTextForEditor(res.data.data[0].answer);
              navigate('/expertHome/editor');
            } else {
              updateAnswerTextForEditor('');
              navigate('/expertHome/editor');
            }
          })
    });
  }
  const convertHtmlToPDF=()=>{
    if(resp.attachmentName !== null && resp.attachmentName !== undefined && resp.attachmentName !== ''){
      let payload =[`${resp.attachmentName}`];
      // openPreviewAttachment(resp?.attachmentName)
      getInlineImage(payload).then((res) => {
        window.open(res.data.data[`${resp.attachmentName}`], "_blank");
      });
    } else {
      toast.error(successfulHelpful("File does not exist!"), {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  const openPreviewAttachment = (file) => {
    let payload = {
      name: file,
    };
    fetchAttachmentURL(payload)
      .then((res) => {
        if (res === undefined) return;
        var response = res.data.data;
        if (
          (file?.includes(".pdf") ||
            file?.includes(".PDF") ||
            file?.includes(".Pdf")) &&
          !file?.includes(".pdf_")
        ) {
          response.src = response.src.replace(
            "data:null",
            "data:application/pdf"
          );
        } else {
          response.src = response.src.replace("data:null", "data:image/png");
        }
        fetch(response.src).then(function (res1) {
          res1.blob().then(function (blob) {
            window.open(URL.createObjectURL(blob), "_blank");
          });
        });
      })
      .catch((err) => {});
  };
  //console.log("response",resp?.attachmentName)
  // const convertHtmlToPDF = () => {
  //   const contentElement = document.getElementById("convertToPDF");

  //   if (!contentElement) {
  //     toast.error(successfulHelpful("No content available to export!"), {
  //       position: toast.POSITION.TOP_RIGHT,
  //     });
  //     return;
  //   }

  //   html2pdf()
  //     .set({
  //       margin: 10,
  //       filename: 'Briefing_Content.pdf',
  //       image: { type: 'jpeg', quality: 0.98 },
  //       html2canvas: { scale: 2 },
  //       jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
  //       pagebreak: { mode: ['css', 'legacy'] }
  //     })
  //     .from(contentElement)
  //     .save();
  // };
  const audioDownload = () => {
    if (audio !== null && audio !== undefined) {
      return;
    }
    // setLoading(true);
    if(resp.audioFileName !== null && resp.audioFileName !== undefined && resp.audioFileName !== ''){
      let payload =[`${resp.audioFileName}`];
      getInlineImage(payload).then((res) => {
       setAudio(res.data.data[`${resp.audioFileName}`]);
      //  setLoading(false);
      })
    }else{
      toast.error(successfulHelpful("File does not exist!"), {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };
  const showRoutingHistoryDate = (start) => {
    let newDate = `${new Date(start).getFullYear()}-${
      new Date(start).getMonth() + 1 > 9
        ? new Date(start).getMonth() + 1
        : new Date(start).getMonth() + 1
    }-${new Date(start).getDate()}`;
    return newDate;
    //   return `${newDate} ${new Date(start).getHours().toString().length >1 ? new Date(start).getHours():'0'+new Date(start).getHours()}:${new Date(start).getMinutes().toString().length >1 ? new Date(start).getMinutes():'0'+new Date(start).getMinutes()}`;
  };
  const successfulHelpful = (message) => {
    return (
      <>
        <span style={{ fontSize: "12px" }}>{message}</span>
      </>
    );
  };
  const textStyles3 = {
    fontSize: "16px",
    color: "#5C667B",
    lineHeight: "32px",
    fontWeight: "300",
    wordBreak: "break-word",
    overflowWrap: "break-word",
    marginTop: "15px",
    overflow: "auto",
    padding: "20px",
    // width:'100%',
    // cursor:'pointer',
  };
  const showDrawer = (val) => {
    localStorage.removeItem("briefQ");
    localStorage.removeItem("agentId");
    setResp(val);
    setIsStep(false);
    setAudio(null);
    setOpen(true);
    setReviewedButtonBoolean(val.reviewed);
  };
  const deleteBrief = (val) => {
    deleteBriefHistory(val.agenticId).then((res) => {
      toast.success(successfulHelpful(res.data.message), {
        position: toast.POSITION.TOP_RIGHT,
      });
      onClickFunc();
    });
  };
  const onClose = () => {
    localStorage.removeItem("briefQ");
    localStorage.removeItem("agentId");
    setAudio(null);
    setOpen(false);
    setResp(null);
  };
  const headTitle = (text) => {
    if (text !== "refresh") {
      return (
        <>
          <span
            style={{ fontSize: "18px", fontWeight: "400", color: "#5D6676" }}
          >
            {text}
          </span>
        </>
      );
    } else {
      return (
        <>
        <div style={{ textAlign: "right" }}>
          <SyncOutlined
            style={{
              fontSize: "22px",
              fontWeight: "100",
              color: "#5D6676",
              cursor: "pointer",
            }}
            onClick={() => onClickFunc()}
          />
        </div>
        {/* <div style={{display:'flex',flexWrap:'wrap',gap:'3px'}}>
          {resp!==null && resp.briefFormat === 'audio'&&
            <Button2 onClickFunc={audioDownload}>
            <i className="fa fa-volume-up" style={{color:'#5c667b', fontSize:'16px'}}></i>
            &nbsp;{audio ? "Audio Available" : "Load Audio"}
          </Button2>
          }
          {!currentPath.pathname.includes('/cmHome')&& !currentPath.pathname.includes('/seekerHome')  && resp?.language==="English" && !resp?.answered && <Button2  onClickFunc={onClickEdit}>
                        <i className="fa fa-edit" style={{color:'#5c667b', fontSize:'16px'}}></i>
&nbsp;Edit Brief
          </Button2>}
        {!currentPath.pathname.includes('/cmHome')&& !currentPath.pathname.includes('/expertHome') && !reviewedButtonBool&& resp?.language==="English" && <Button2  onClickFunc={reviewContent}>
                        <i className="fa fa-eye" style={{color:'#5c667b', fontSize:'16px'}}></i>
&nbsp;Submit for Review
          </Button2>}
          {!currentPath.pathname.includes('/cmHome')&& !currentPath.pathname.includes('/expertHome') && !reviewedButtonBool&& resp?.language !=="English" && <TooltipComp title={'Expert review limited to English briefs at this time'}><div style={{opacity:'.7'}}><Button2 disabled={true}   onClickFunc={reviewContent}>
                        <i className="fa fa-eye" style={{color:'#5c667b', fontSize:'16px'}}></i>
&nbsp;Submit for Review
          </Button2></div></TooltipComp>}
          {!currentPath.pathname.includes('/cmHome')&& !currentPath.pathname.includes('/expertHome') && reviewedButtonBool&&<Button2 onClickFunc={()=>{console.log()}} disabled={reviewedButtonBool}>
          Reviewed
          </Button2>}
          {/* reviewedButtonBool */}
          {/* <Button2 onClickFunc={showSteps}>
            <img src={require("../../../Images/foot.png")} style={{ width: "20px" }} />
            &nbsp;{isStep ? "Hide Steps" : "Show Steps"}
          </Button2>
          
        <Button2 onClickFunc={convertHtmlToPDF}>
            <PdfWhiteIcon />
            &nbsp;Export As Pdf
          </Button2>
          
          <Button2 onClickFunc={copyToClipboard}>
            <CopyIcon />
            &nbsp;Copy
          </Button2>
        </div> */} 
      </>
    );
  }
}

  function htmlToFormattedText(html) {
    let doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.innerText; // Preserves line breaks and spacing
  }
  const onClickCopy = () => {
    toast.success(successfulHelpful("Text copied!"), {
      position: toast.POSITION.TOP_RIGHT,
    });
    let newString = htmlToFormattedText(resp);
    navigator.clipboard.writeText(`${newString}`);
  };
  const copyToClipboard = () => {
    if (pdfRef.current) {
      const range = document.createRange();
      range.selectNodeContents(pdfRef.current);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);

      document.execCommand("copy"); // Copies as rich text

      selection.removeAllRanges(); // Clear selection
      toast.success(successfulHelpful("Brief copied!"), {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };
  const showSteps = () => {
    setIsStep(!isStep);
  };

  const reviewContent = () => {
    if (resp.language === "English") {
      localStorage.setItem("briefQ", resp.userQuery);
      localStorage.setItem("agentId", resp.agenticId);
      // Optimistically reflect "Awaiting" immediately for current brief
      setOptimisticSubmitted((prev) => new Set(prev).add(resp?.agenticId));
      setPendingAgenticId(resp?.agenticId);
      advanceFilterModalToggle({ bool: true, value: "agentReview" });
    }
  };

  const handleSubmitForReview = (row) => {
    suppressUntilLeave(row.agenticId);
    if (
      row?.status === "completed" &&
      row?.language === "English" &&
      row?.reviewed === false
    ) {
      localStorage.setItem("briefQ", row.userQuery);
      localStorage.setItem("agentId", row.agenticId);
      setOptimisticSubmitted((prev) => new Set(prev).add(row?.agenticId));
      setPendingAgenticId(row?.agenticId);
      advanceFilterModalToggle({ bool: true, value: "agentReview" });
    }
  };
  const attachmentToolTip = (file) => { 
    const onClickFunc=(name)=>{
      let payload =[name];
      getInlineImage(payload).then(res=>{
        window.open(res.data.data[name], "_blank");
      })
    }
  return(
    <>
    {file.map(dt=>{
      return <Tag onClick={()=>onClickFunc(dt)} style={{color:'#5c667b', cursor:'pointer'}}>{dt}</Tag>
    })}
    </>
  )
  }
  const columns = [
    {
      title: headTitle("Date"),
      dataIndex: "createdAt",
      key: "createdAt",
      // width: "10%",
      sort: true,
      render: (_, raw) => {
        return (
          <>
            <span
              style={{
                fontSize: "16px",
                fontWeight: "300",
                wordBreak: "break-word",
                overflowWrap: "break-word",
                color: "#5C667B",
              }}
            >
              <div>{showRoutingHistoryDate(raw.createdAt)}</div>
              <div>{moment(raw.createdAt).format("HH:mm")}</div>
              {/* <div>{moment(raw.modifiedAt).format("hh:mm A")}</div> */}
            </span>
          </>
        );
      },
    },
    {
      title: headTitle("Language / Output"),
      dataIndex: "language",
      key: "language",
      width: "15%",
      render: (_, raw) => {
        return (
          <>
            <span
              style={{ fontSize: "16px", fontWeight: "300", color: "#5C667B" }}
            >
              {raw.language}&nbsp; / &nbsp;
              {raw.briefFormat.charAt(0).toUpperCase() +
                raw.briefFormat.slice(1)}
            </span>
          </>
        );
      },
    },
    //  {
    //   title: headTitle("Sources"),
    //   dataIndex: "sources",
    //   key: "sources",
    //   // width: "8%",
    //   render: (_, raw) => {
    //     return (
    //       <>
    //         <span
    //           style={{ fontSize: "16px", fontWeight: "300", color: "#5C667B" }}
    //         >
    //           {raw.sources && raw.sources.length > 0
    //             ? raw.sources.split(',').map((source, index) => (
    //                 <span key={index}>
    //                   {source}
    //                   {index < raw.sources.split(',').length - 1 ? ", " : ""}
    //                 </span>
    //               ))
    //             : "N/A"}
    //         </span>
    //       </>
    //     );
    //   },
    // },
    {
      title: headTitle("Briefing Request"),
      dataIndex: "userQuery",
      key: "userQuery",
      width: "65%",
      render: (_, raw) => {
        return (
          <>
            <span
              style={{
                fontSize: "16px",
                fontWeight: "300",
                color: "#0075FF",
                cursor: "pointer",
                textDecoration: "underline",
              }}
              onClick={() => showDrawer(raw)}
            >
              {raw.userQuery}
            </span>
            <div>
              {raw.sources &&
                raw.sources.length > 0 &&
                raw.sources.split(",").map((source, index) => (
                  <span key={index}>
                    <Tag
                      style={{
                        color: "#fff",
                        background:
                          "linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)",
                        borderColor: "#fff",
                      }}
                    >
                      {source}
                    </Tag>
                    &nbsp;
                  </span>
                ))}
                {raw.knowledgeAttachments?.length > 0 && <TooltipComp title={attachmentToolTip(raw.knowledgeAttachments)}>
                  <Tag
                      style={{
                        color: "#fff",
                        background:
                          "linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)",
                        borderColor: "#fff",
                        cursor:"pointer"
                      }}
                    >
                      Attachments
                    </Tag>
                  </TooltipComp>}
            </div>
          </>
        );
      },
    },
    {
      title: headTitle("refresh"),
      dataIndex: "",
      key: "",
      width: "10%",
      render: (_, raw) => {
        const submitTipId = `${raw.agenticId}-submit`;
        const awaitingTipId = `${raw.agenticId}-awaiting`;
        return (
          <>
            {/* { raw.briefOutput !== null && */}
            {CURRENT_ROLE !=='Seeker'&&
              <div style={{textAlign:"right"}}>
                <DeleteIcon
                  style={{ cursor: "pointer", margin: "10px" }}
                  onClick={() => deleteBrief(raw)}
                />
              </div>
            }
            { CURRENT_ROLE==='Seeker'&& <div onMouseLeave={() => clearSuppression(raw.agenticId)}>
              <span
                style={{
                  fontSize: "16px",
                  color: "#5C667B",
                  fontWeight: "300",
                  display: "flex",
                  justifyContent: "end",
                  alignItems: "center",
                }}
              >
                {raw.saved && (
                  <Rate
                    count={1}
                    disabled
                    value={1}
                    style={{ marginRight: "15px" }}
                  />
                )}
                {raw?.status === "completed" &&
                raw?.language === "English" && 
                !isAwaiting(raw) && 
                raw?.reviewed === false ? (
                  <TooltipComp
                    destroyTooltipOnHide
                    // getPopupContainer={(node) => node}
                    open={isTipOpen(submitTipId)}
                    onOpenChange={(v) => {
                      if (tipSuppressUntilLeave.has(raw.agenticId)) return;
                      setTooltipOpenId(v ? submitTipId : null);
                    }}
                    overlayStyle={{ zIndex: 900 }}
                    title={
                      <span style={{ fontWeight: 400, padding: "4px" }}>
                        Submit Brief for Expert Approval
                      </span>
                    }
                  >
                    <div
                      onClick={() => {
                        setTooltipOpenId(null);
                        suppressUntilLeave(raw.agenticId);
                        handleSubmitForReview(raw);
                      }}
                      // 2) if we hover while suppressed, clear and allow this hover to open
                      onMouseEnter={() => {
                        if (tipSuppressUntilLeave.has(raw.agenticId)) {
                          clearSuppression(raw.agenticId);
                          setTooltipOpenId(submitTipId); // open on this very hover
                        }
                      }}
                      // 3) clear suppression when pointer leaves the icon (more reliable than wrapper leave)
                      onMouseOut={() => clearSuppression(raw.agenticId)}
                      style={{ cursor: "pointer" }}
                    >
                      <SubmitIcon />
                    </div>
                  </TooltipComp>
                ) : raw?.status === "completed" &&
                  raw?.language !== "English" &&
                  raw?.reviewed === false ? (
                  // Disabled for non-English: greyed out with tooltip
                  <TooltipComp
                    title={
                      <span style={{ fontWeight: 400, padding: 4 }}>
                        Expert review limited to English briefs at this time
                      </span>
                    }
                  >
                    <span
                      aria-disabled="true"
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        opacity: 0.45,
                        cursor: "not-allowed",
                      }}
                    >
                      <SubmitIcon />
                    </span>
                  </TooltipComp>
                ) : isAwaiting(raw) && raw?.reviewed === false ? (
                  <TooltipComp
                    destroyTooltipOnHide
                    overlayStyle={{ zIndex: 900 }}
                    open={isTipOpen(awaitingTipId)}
                    onOpenChange={(v) => {
                      if (tipSuppressUntilLeave.has(raw.agenticId)) return;
                      setTooltipOpenId(v ? awaitingTipId : null);
                    }}
                    title={
                      <span style={{ fontWeight: 400, padding: "4px" }}>
                        Brief awaiting Expert Approval
                      </span>
                    }
                  >
                    <div
                      onMouseEnter={() => {
                        if (tipSuppressUntilLeave.has(raw.agenticId)) {
                          clearSuppression(raw.agenticId);
                          setTooltipOpenId(awaitingTipId); // open on this very hover
                        }
                      }}
                      // 3) clear suppression when pointer leaves the icon (more reliable than wrapper leave)
                      onMouseOut={() => clearSuppression(raw.agenticId)}
                    >
                      <AwaitingIcon />
                    </div>
                  </TooltipComp>
                ) : raw?.reviewed === true ? (
                  <TooltipComp
                    title={
                      <span style={{ fontWeight: 400, padding: "4px" }}>
                        Brief Approved by Expert
                      </span>
                    }
                  >
                    <ApprovedIcon />
                  </TooltipComp>
                ) : null}
                <DeleteIcon
                  style={{ cursor: "pointer", margin: "10px" }}
                  onClick={() => deleteBrief(raw)}
                />
                {/* {raw.briefOutput !== null && raw.briefOutput !== "" && <i  className="fas fa-ellipsis-v" style={{cursor:'pointer', marginLeft:'15px'}} onClick={() => showDrawer(raw)} ></i>} */}
              </span>
            </div>}
          </>
        );
      },
    },
  ];
  const cmColumns = [
    {
      title: headTitle("Date"),
      dataIndex: "createdAt",
      key: "createdAt",
      width: "10%",
      sort: true,
      render: (_, raw) => {
        return (
          <>
            <span
              style={{
                fontSize: "16px",
                fontWeight: "300",
                wordBreak: "break-word",
                overflowWrap: "break-word",
                color: "#5C667B",
              }}
            >
              <div> {showRoutingHistoryDate(raw.createdAt)}</div>
              <div>{moment(raw.createdAt).format("HH:mm")}</div>
              {/* <div>{moment(raw.modifiedAt).format("hh:mm A")}</div> */}
            </span>
          </>
        );
      },
    },
    {
      title: headTitle("Agent Run Time"),
      dataIndex: "createdAt",
      key: "createdAt",
      width: "15%",
      sort: true,
      render: (_, raw) => {
        return (
          <>
            <span
              style={{
                fontSize: "16px",
                fontWeight: "300",
                wordBreak: "break-word",
                overflowWrap: "break-word",
                color: "#5C667B",
              }}
            >
              <div>{moment(raw.modifiedAt).diff(moment(raw.createdAt), "minutes")}&nbsp;minutes</div>
              {/* <div>{moment(raw.createdAt).format("HH:mm")}</div> */}
              {/* <div>{moment(raw.modifiedAt).format("hh:mm A")}</div> */}
            </span>
          </>
        );
      },
    },
    {
      title: headTitle("Language / Output"),
      dataIndex: "language",
      key: "language",
      width: "8%",
      render: (_, raw) => {
        return (
          <>
            <span
              style={{ fontSize: "16px", fontWeight: "300", color: "#5C667B" }}
            >
              {raw.language}&nbsp; / &nbsp;
              {raw.briefFormat.charAt(0).toUpperCase() +
                raw.briefFormat.slice(1)}
            </span>
          </>
        );
      },
    },
    {
      title: headTitle("Name"),
      dataIndex: "userName",
      key: "userName",
      width: "8%",
      render: (_, raw) => {
        return (
          <>
            <div
              style={{ fontSize: "16px", fontWeight: "300", color: "#5C667B" }}
            >
              {raw.userName ? raw.userName.split(" ")[0] : "Anonymous"}
            </div>
            <div
              style={{ fontSize: "16px", fontWeight: "300", color: "#5C667B" }}
            >
              {raw.userName ? raw.userName.split(" ")[1] : "Anonymous"}
            </div>
          </>
        );
      },
    },
    // {
    //   title: headTitle("Sources"),
    //   dataIndex: "sources",
    //   key: "sources",
    //   width: "10%",
    //   render: (_, raw) => {
    //     return (
    //       <>
    //         <span
    //           style={{ fontSize: "16px", fontWeight: "300", color: "#5C667B" }}
    //         >
    //           {raw.sources && raw.sources.length > 0
    //             ? raw.sources.split(',').map((source, index) => (
    //                 <span key={index}>
    //                   {source}
    //                   {index !== raw.sources.split(',').length-1 ? ", ":""}
    //                 </span>
    //               ))
    //             : "N/A"}
    //         </span>
    //       </>
    //     );
    //   },
    // },
    {
      title: headTitle("Briefing Request"),
      dataIndex: "userQuery",
      key: "userQuery",
      width: "65%",
      render: (_, raw) => {
        return (
          <>
            <span
              style={{
                fontSize: "16px",
                fontWeight: "300",
                color: "#0075FF",
                cursor: "pointer",
                textDecoration: "underline",
              }}
              onClick={() => showDrawer(raw)}
            >
              {raw.userQuery}
            </span>
            <div>
              {raw.sources &&
                raw.sources.length > 0 &&
                raw.sources.split(",").map((source, index) => (
                  <span key={index}>
                    <Tag
                      style={{
                        color: "#fff",
                        background:
                          "linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)",
                        borderColor: "#fff",
                      }}
                    >
                      {source}
                    </Tag>
                    &nbsp;
                  </span>
                ))}
                {raw.knowledgeAttachments?.length > 0 && <TooltipComp title={attachmentToolTip(raw.knowledgeAttachments)}>
                  <Tag
                      style={{
                        color: "#fff",
                        background:
                          "linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)",
                        borderColor: "#fff",
                        cursor:"pointer"
                      }}
                    >
                      Attachments
                    </Tag>
                  </TooltipComp>}
            </div>
          </>
        );
      },
    },
    {
      title: headTitle("refresh"),
      dataIndex: "",
      key: "",
      width: "5%",
      render: (_, raw) => {
        return (
          <>
            {/* { raw.briefOutput !== null && */}
            <div>
              <span
                style={{
                  fontSize: "16px",
                  color: "#5C667B",
                  fontWeight: "300",
                  display: "flex",
                  justifyContent: "end",
                  alignItems: "center",
                }}
              >
                {raw.saved && (
                  <Rate
                    count={1}
                    disabled
                    value={1}
                    style={{ marginRight: "15px" }}
                  />
                )}
                <DeleteIcon
                  style={{ cursor: "pointer" }}
                  onClick={() => deleteBrief(raw)}
                />
                {/* {raw.briefOutput !== null && raw.briefOutput !== "" && <i  className="fas fa-ellipsis-v" style={{cursor:'pointer', marginLeft:'15px'}} onClick={() => showDrawer(raw)} ></i>} */}
              </span>
            </div>
          </>
        );
      },
    },
  ];

  return (
    <>
      <Table
        // rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' :  'table-row-dark'}
        className={styles.noGridlines}
        columns={CURRENT_ROLE === 'Seeker' || CURRENT_ROLE === 'Expert' ? columns : cmColumns}
        pagination={false}
        dataSource={data}
        style={{ border: "1px solid #f2f2f2", borderRadius: "8px" }}
      />
      <BriefModal
        open={open}
        onClose={onClose}
        resp={resp}
        isStep={isStep}
        onToggleSteps={showSteps}
        audioUrl={audio}
        onPlayAudio={audioDownload}
        onConvertPdf={convertHtmlToPDF}
        onCopy={copyToClipboard}
        onSubmitForReview={reviewContent}
        reviewed={reviewedButtonBool}
        submittedForReview={isAwaiting(resp)}
        language={resp?.language}
        contentRef={pdfRef}
        currentRole={CURRENT_ROLE}
        onClickEdit={onClickEdit}
        loading={loading}
      />
      {/* <Spin spinning={loading}>
        <Drawer
        title={headDrawer("Briefing Response")}
        onClose={onClose}
        width={"80%"}
        open={open}
      >
        <Spin spinning={loading}>
        {audio !== null && <div style={{textAlign:'end'}}>
          <audio controls>
        <source src={audio} type="audio/mp3"/>
          Your browser does not support the audio tag.
        </audio>
        </div>}
       { !isStep && <div
        id="convertToPDF"
            ref={pdfRef}
          style={textStyles3}
        >
          <Content text={resp===null?"":resp.briefOutput} />
        </div>}
        { isStep && <div
        id="convertToPDF"
            ref={pdfRef}
          style={textStyles3}
          dangerouslySetInnerHTML={{ __html: resp===null?"":resp.processingSteps }}
        ></div>}
        </Spin>
      </Drawer> */}
      {/* </Spin> */}
    </>
  );
}

